import React from 'react';
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import style from './SecondStep.module.scss';
import {Container, Row, Col} from "react-bootstrap";
import Select from "react-select";
import {reactSelectStyle} from "../../reactSelect";
import {Input, RadioGroup, RadioButton, FormField} from '../../../../components/index';
import validator from "./SecondStep.validator";
import bedroomsOptions from "../../../../asset/data/bedrooms";
import parkingsOptions from "../../../../asset/data/parkings";
import * as cabinetActions from "../../../../redux/action/cabinet.action";
import * as documentActions from "../../../../redux/action/document.action";
import * as functions from "../../../../helper/functions";

class SecondStep extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      property: {
        overallPrice: '',
        segmentPrice: '',
        convertiblePrice: false,
        foundation: '',
        age: '',
        propertyBedrooms: '',
        totalFloors: '',
        totalUnitsPerFloor: '',
        sideLength: '',
        passageWidth: '',
        cabinet: null,
        document: null,
        parkingSpace: '',
        wareHouse: false,
        elevator: false
      },
      validations: {},
      documents: [],
      cabinets: []
    }
  }

  async componentDidMount() {
    await this.fetchCabinets();
    await this.fetchDocuments();

    this.resetState(this.props.data);
  }

  async resetState(data) {
    const { overallPrice = '', segmentPrice = '', convertiblePrice = false, foundation = '', age = '', propertyBedrooms = '', totalFloors = '', totalUnitsPerFloor = '', cabinet = null, document = null, parkingSpace = '', wareHouse = false, elevator = false, sideLength = '', passageWidth = '' } = data;
    
    await this.setState({
      property: {overallPrice, segmentPrice, convertiblePrice, foundation, age, propertyBedrooms, totalFloors, totalUnitsPerFloor, cabinet, document, parkingSpace, wareHouse, elevator, sideLength, passageWidth},
      validations: {},
    });
  }

  async fetchCabinets() {
    const response = await this.props.findCabinets();
    await this.setState({ cabinets: response.map((item) => {
        return { value: item.id, label: item.title }
      })});
  }

  async fetchDocuments() {
    const response = await this.props.fetchDocuments();
    await this.setState({ documents: response.map((item) => {
        return { value: item.id, label: item.title }
      })});
  }

  changeForm(key, value, callback = null) {
    let {property, validations} = this.state;

    this.setState(prevState => (
        {
          property: {...prevState.property, [key]: value},
        }), () => {
      property = this.state.property;
      const validation = validator.validate({ [key]: property[key] });
      this.setState({
        validations: { ...validations, [key]: validation[key] }
      });
      if (callback) {
        callback.bind(this).call();
      }
    });
  }

  submitForm = async () => {
    const { onNext } = this.props;
    const { property } = this.state;

    const validation = validator.validate(property);
    this.setState({validations: validation});

    if (!validation.isValid) {
      functions.errorToast('اطلاعات را به درستی وارد کنید');
      return;
    }

    await onNext(property);
  };

  render() {
    const { cabinets, documents, validations } = this.state;
    const { onBack, propertyType, transactionType } = this.props;
    const { overallPrice, segmentPrice, convertiblePrice, foundation, age, propertyBedrooms, totalFloors, totalUnitsPerFloor, cabinet, document, parkingSpace, wareHouse, elevator, sideLength, passageWidth } = this.state.property;

    const overallPriceText = transactionType === 'RENT' ? 'مبلغ قرض الحسنه' : 'مبلغ کل';
    const segmentPriceText = transactionType === 'RENT' ? 'مبلغ اجاره' : 'مبلغ متری';

    return (
        <Container>
          <Row className={'mb-2'}>
            <Col>
              <span className={style.form_section_title}>اطلاعات مالی</span>
            </Col>
          </Row>
          <Row>
            <Col sm={6} md={4} className={'mb-3'}>
              <Input type={'text'} label={overallPriceText} placeholder={overallPriceText} value={overallPrice} onChange={(value) => {
                this.changeForm('overallPrice', value);
              }} />
            </Col>
            <Col sm={6} md={4} className={'mb-3'}>
              <Input type={'text'} label={segmentPriceText} placeholder={segmentPriceText} value={segmentPrice} onChange={(value) => {
                this.changeForm('segmentPrice', value);
              }} />
            </Col>
            <Col sm={12} md={4} className={'mb-3'}>
              <RadioButton
                  text={'قابل تبدیل'}
                  isChecked={convertiblePrice}
                  className={style.single_radio}
                  onChange={(value) => {
                    this.changeForm('convertiblePrice', value);
                  }}
              />
            </Col>
          </Row>
          <Row className={`mb-2 ${style.header}`}>
            <Col>
              <span className={style.form_section_title}>اطلاعات تکمیلی</span>
            </Col>
          </Row>
          <Row className={`${style.location_row}`}>
            <Col sm={6} lg={'1'} className={'mb-3'}>
              <FormField validation={validations.foundation}>
                <Input type={'text'} label={'متراژ'} placeholder={'متراژ'} value={foundation} onChange={(value) => {
                  this.changeForm('foundation', value);
                }} />
              </FormField>
            </Col>
            <Col sm={6} lg={'1'} className={'mb-3'}>
              <Input type={'text'} label={'سن بنا'} placeholder={'سن بنا'} value={age} onChange={(value) => {
                this.changeForm('age', value);
              }} />
            </Col>
            {
              ((propertyType === 'APARTMENT') || (propertyType === 'SUITE') || (propertyType === 'S_OFFICE') || (propertyType === 'M_OFFICE')) && (
                  <Col sm={6} lg={'2'} className={'mb-3'}>
                    <Select
                        placeholder="تعداد خواب"
                        className="react-select"
                        closeMenuOnSelect={true}
                        styles={reactSelectStyle}
                        isMulti={false}
                        isClearable={"true"}
                        onChange={(newValue) => {
                          this.changeForm("propertyBedrooms", newValue ? newValue.value : '');
                        }}
                        value={bedroomsOptions ? bedroomsOptions.filter((opt) => opt.value === propertyBedrooms) : ''}
                        options={bedroomsOptions.slice(0)}
                    />
                  </Col>
              )
            }
            {
              ((propertyType === 'APARTMENT') || (propertyType === 'SUITE') || (propertyType === 'S_OFFICE') || (propertyType === 'M_OFFICE') || (propertyType === 'OLD_PROPERTY')|| (propertyType === 'VILLA') || (propertyType === 'TENEMENT')) && (
                  <Col sm={6} lg={'2'} className={'mb-3'}>
                    <Input type={'text'} label={'تعداد طبقات'} placeholder={'تعداد طبقات'} value={totalFloors} onChange={(value) => {
                      this.changeForm('totalFloors', value);
                    }} />
                  </Col>
              )
            }
            {
              ((propertyType === 'APARTMENT') || (propertyType === 'SUITE') || (propertyType === 'S_OFFICE') || (propertyType === 'M_OFFICE') || (propertyType === 'OLD_PROPERTY')|| (propertyType === 'VILLA') || (propertyType === 'TENEMENT')) && (
                  <Col sm={6} lg={'2'} className={'mb-3'}>
                    <Input type={'text'} label={'تعداد واحد در طبقه'} placeholder={'تعداد واحد در طبقه'} value={totalUnitsPerFloor} onChange={(value) => {
                      this.changeForm('totalUnitsPerFloor', value);
                    }} />
                  </Col>
              )
            }
            {
              ((propertyType === 'OLD_PROPERTY')|| (propertyType === 'VILLA') || (propertyType === 'COMMERCIAL') || (propertyType === 'STORE')) && (
                  <Col sm={6} lg={'2'} className={'mb-3'}>
                    <Input type={'text'} label={'طول بر'} placeholder={'طول بر'} value={sideLength} onChange={(value) => {
                      this.changeForm('sideLength', value);
                    }} />
                  </Col>
              )
            }
            {
              ((propertyType === 'OLD_PROPERTY')|| (propertyType === 'VILLA') || (propertyType === 'COMMERCIAL') || (propertyType === 'STORE')) && (
                  <Col sm={6} lg={'2'} className={'mb-3'}>
                    <Input type={'text'} label={'عرض گذر'} placeholder={'عرض گذر'} value={passageWidth} onChange={(value) => {
                      this.changeForm('passageWidth', value);
                    }} />
                  </Col>
              )
            }
            {
              ((propertyType === 'APARTMENT') || (propertyType === 'SUITE') || (propertyType === 'S_OFFICE') || (propertyType === 'M_OFFICE')) && (
                  <Col sm={6} lg={'2'} className={'mb-3'}>
                    <Select
                        placeholder="نوع کابینت"
                        className="react-select"
                        closeMenuOnSelect={true}
                        styles={reactSelectStyle}
                        isMulti={false}
                        isClearable={"true"}
                        onChange={(newValue) => {
                          this.changeForm("cabinet", newValue ? newValue.value : '');
                        }}
                        value={cabinets ? cabinets.filter((opt) => opt.value === cabinet) : ''}
                        options={cabinets}
                    />
                  </Col>
              )
            }
            {
              ((propertyType === 'APARTMENT') || (propertyType === 'SUITE') || (propertyType === 'S_OFFICE') || (propertyType === 'M_OFFICE') || (propertyType === 'COMMERCIAL') || (propertyType === 'STORE') || (propertyType === 'TENEMENT')) && (
                  <Col sm={6} lg={'2'} className={'mb-3'}>
                    <Select
                        placeholder="تعداد پارکینگ"
                        className="react-select"
                        closeMenuOnSelect={true}
                        styles={reactSelectStyle}
                        isMulti={false}
                        isClearable={"true"}
                        onChange={(newValue) => {
                          this.changeForm("parkingSpace", newValue ? newValue.value : '');
                        }}
                        value={parkingsOptions ? parkingsOptions.filter((opt) => opt.value === parkingSpace) : ''}
                        options={parkingsOptions}
                    />
                  </Col>
              )
            }
          </Row>
          {
            ((propertyType === 'APARTMENT') || (propertyType === 'SUITE') || (propertyType === 'S_OFFICE') || (propertyType === 'M_OFFICE') || (propertyType === 'OLD_PROPERTY') || (propertyType === 'VILLA') || (propertyType === 'TENEMENT')) && (
                <React.Fragment>
                  <Row className={`mb-2 ${style.header}`}>
                    <Col>
                      <span className={style.form_section_title}>کاربری سند</span>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <RadioGroup options={documents} value={document} containerClass={style.radio_container} itemClass={style.radio_item} onChange={(value) => {
                        this.changeForm('document', value)
                      }} />
                    </Col>
                  </Row>
                </React.Fragment>
            )
          }

          <Row className={`mb-2 ${style.header}`}>
            <Col>
              <span className={style.form_section_title}>سایر امکانات</span>
            </Col>
          </Row>
          <Row>
            <Col>
              {
                ((propertyType === 'APARTMENT') || (propertyType === 'SUITE') || (propertyType === 'S_OFFICE') || (propertyType === 'M_OFFICE') || (propertyType === 'COMMERCIAL') || (propertyType === 'STORE') || (propertyType === 'TENEMENT')) && (
                    <RadioButton
                        text={'انباری'}
                        isChecked={wareHouse}
                        className={style.single_radio}
                        onChange={(value) => {
                          this.changeForm('wareHouse', value);
                        }}
                    />
                )
              }
              {
                ((propertyType === 'APARTMENT') || (propertyType === 'SUITE') || (propertyType === 'S_OFFICE') || (propertyType === 'M_OFFICE') || (propertyType === 'COMMERCIAL') || (propertyType === 'STORE') || (propertyType === 'TENEMENT')) && (
                    <RadioButton
                        text={'آسانسور'}
                        isChecked={elevator}
                        className={style.single_radio}
                        onChange={(value) => {
                          this.changeForm('elevator', value);
                        }}
                    />
                )
              }
            </Col>
          </Row>
          <Row className={'mt-3'}>
            <Col>
              <div className={`${style.button_container}`}>
                <button type="button" className={`btn btn-light btn-sm ml-2 ${style.back_button}`} onClick={() => {
                  onBack(this.state.property);
                }}>
                  بازگشت
                </button>
                <button type="button" className={`btn btn-primary btn-sm `} onClick={() => {
                  this.submitForm();
                }}>
                  ثبت ملک
                </button>
              </div>
            </Col>
          </Row>
        </Container>
    );
  }
}

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
  findCabinets: () => dispatch(cabinetActions.findCabinets()),
  fetchDocuments: () => dispatch(documentActions.fetchDocuments()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SecondStep));
